export const CAMPEON = 'C';
export const SUBCAMPEON = 'S';
export const ASCENSO = 'A';
export const DESCENSO = 'D';
